// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"455":"e8dfbb2e","956":"7fd10984"}[chunkId] + ".css";
};